import React, {useState} from 'react';
import {SecurityAdapter} from "../redux/adapters/SecurityAdapter";

export function SecurityModal() {
    return (
        <>
            <div className="ui basic modal" id={"securityModal"}>
                <i className={"close icon"}></i>
                <SecurityAdapter container={"modal"}/>
            </div>
        </>
    )
}

export function SecurityPage() {
    return (
        <>
            <SecurityAdapter container={"page"}/>
        </>
    )
}
